var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTodayPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(87 193 35)",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 31.533 31.533",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.038,3.009c-1.004-1.011-2.758-1.018-3.769-0.015c-1.043,1.034-1.051,2.725-0.016,3.769 c2.909,2.932,3.728,7.125,2.137,10.945c-1.259,3.021-4.411,6.248-9.487,6.248c-4.322,0-8.041-2.385-9.706-6.223 c-1.626-3.75-0.904-7.931,1.885-10.91c1.004-1.073,0.948-2.762-0.125-3.767C6.926,2.091,5.156,2.149,4.191,3.181 c-4.263,4.556-5.367,10.945-2.882,16.674c2.522,5.817,8.115,9.432,14.595,9.432c6.438,0,11.958-3.65,14.407-9.528 C32.744,13.914,31.491,7.497,27.038,3.009z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayPay);
export default __webpack_public_path__ + "static/media/todayPay.71d3d966cef330d496209b0ba4e182a7.svg";
export { ForwardRef as ReactComponent };